var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href:
            "//fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic"
        }
      }),
      _vm._v(" "),
      _c("link", {
        attrs: {
          href: "https://fonts.googleapis.com/css?family=Poppins:300,400",
          rel: "stylesheet"
        }
      }),
      _vm._v(" "),
      _c("link", {
        attrs: {
          href: "https://fonts.googleapis.com/css?family=Roboto+Slab:300,400",
          rel: "stylesheet"
        }
      }),
      _vm._v(" "),
      _c("link", {
        attrs: {
          rel: "stylesheet",
          href: "https://use.fontawesome.com/releases/v5.6.3/css/all.css"
        }
      }),
      _vm._v(" "),
      _vm.favicon
        ? _c("link", { attrs: { rel: "icon", href: _vm.favicon } })
        : _c("link", {
            attrs: {
              rel: "icon",
              href:
                "https://storage.googleapis.com/protopia/images/protopia_favicon.png"
            }
          }),
      _vm._v(" "),
      _c("router-view", {
        attrs: { auth: _vm.auth, authenticated: _vm.authenticated }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 